import styled from 'styled-components';

export const ContainerBtns = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
`;